import { $apiClient, $asyncCache, $auth, $businessUnit, $model, mapViewRow } from '@msdk/common'
import { EntityModel, StringValue, User, ViewModel } from '@msdk/definitions'
import { selector } from 'recoil'
import { MAX_INT } from 'utils'

export const $businessUnitList = selector({
  key: 'BusinessUnitDetail',
  get: async ({ get }) => {
    const client = get($apiClient)
    const cache = get($asyncCache)
    const bu = get($businessUnit)
    const userData = get($auth) as User
    const userId = userData.profile.user_id
    if (bu) {
      const model = get($model('CMPS'))
      const entityModel = model.getExternalEntity('BUSINESS_UNIT', 'CMPS') as EntityModel
      const viewModel = entityModel.getView('BUSINESS_UNIT_SELECTION') as ViewModel
      const mapped = await cache.getOrCreate('$businessUnitList.BUSINESS_UNIT_SELECTION', async () => {
        const res = await client.entity.getView('CMPS', entityModel, 'BUSINESS_UNIT_SELECTION', {
          filters: {
            '@USER_ID': new StringValue(userId),
          },
          pageSize: MAX_INT,
        })
        const result = res.source.map((row) => mapViewRow(row, entityModel, viewModel, 'CMPS'))
        return result
      })

      return mapped
    }
    return []
  },
})
